<template>
	<div class="establishment">
		<div>
			<b-card no-body>
				<b-tabs pills card vertical>
					<b-tab title="consultar">
        <div id="establishment-list"> 
            <span>Titulo:</span> {{establishmentInfo.title}}<br/>
            <span>Descriçao:</span> {{establishmentInfo.description}}<br/>
            <span>Email:</span> {{establishmentInfo.email}}<br/>
            <span>Telefone:</span> {{establishmentInfo.phone}}<br/>
            <span>Morada:</span> {{establishmentInfo.address}}<br/>
            <span>Hora de abertura:</span> {{establishmentInfo.openingHour}}<br/>
            <span>Hora de fecho:</span> {{establishmentInfo.closingHour}}<br/>
            <span>Imagem:</span> {{establishmentInfo.images}}<br/>
            <span>Titulo do Menu:</span> {{establishmentInfo.menuTitle}}<br/>
            <span>Images do Menu:</span> {{establishmentInfo.menuImages}}<br/>
            <span>Descriçao do Menu:</span> {{establishmentInfo.menuDescription}}<br/>
        </div>
					</b-tab>
					<b-tab title="Alterar" active>
            <form-establishment :establishment="establishmentInfo"></form-establishment>
					</b-tab>
				</b-tabs>
			</b-card>
		</div>
	</div>
</template>

<script>
import api from '../api'
import formEstablishment from '../components/Establishment/formEstablishment'
import { mapGetters, mapActions } from 'vuex';
export default {
  name: "establishment",
  components: {
    formEstablishment
  },
	data() {
		return {
		}
  },
  mounted(){
    this.refreshData()
  },
  computed: {
    ...mapGetters(['establishmentInfo'])
  },
  methods: {
    ...mapActions(['refreshInfo']),
    refreshData(){
      this.refreshInfo()
    }
  }
}
</script>

<style lang='css'>
.establishment a {
  color: #53574D !important;
}
#establishment-list{
  text-align: left;
}
#establishment-list span {
  color: #53574D;
  font-size: x-large;
}
</style>
